/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InquiryTransHistoryDto } from '../models/InquiryTransHistoryDto';
import type { TransHistoryH2hEntity } from '../models/TransHistoryH2hEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BidvH2HService {
  /**
   * Vấn tin lịch sử giao dịch BIDV theo provider của Company
   * @param requestBody
   * @returns TransHistoryH2hEntity
   * @throws ApiError
   */
  public static bidvH2HControllerInquiryTransHistory(
    requestBody: InquiryTransHistoryDto,
  ): CancelablePromise<TransHistoryH2hEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv/h2h/trans-history/inquiry',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
